import { MainComponent  } from './main/main.component';
import { SummaryComponent  } from './summary/summary.component';
import { SummaryUsageComponent  } from './summary/components/summary-usage/summary-usage.component';
import { SummaryDatePickerComponent  } from './summary/components/summary-date-picker/summary-date-picker.component';
import { SummaryFormComponent  } from './summary/components/summary-form/summary-form.component';
import { InstitutionListComponent  } from './institution-list/institution-list.component';

export const Dashboard = [
  MainComponent,
  SummaryComponent,
  SummaryUsageComponent,
  SummaryDatePickerComponent,
  SummaryFormComponent,
  InstitutionListComponent
]

export {
  MainComponent,
  SummaryComponent,
  SummaryUsageComponent,
  SummaryFormComponent,
  InstitutionListComponent
}

